import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import { fetchMonthWiseRangeSales, fetchStateWiseRangeSales, fetchStateWiseSales, getTop50DealersPayments, getTop50DealersSales } from '@/api/orders-dispatches';
import { Component, Vue } from 'vue-property-decorator';
import VueApexCharts from 'vue-apexcharts';
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import * as XLSX from 'xlsx';
import moment from 'moment';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.top50dealersSales = [];
    this.top50dealersPayments = [];
    this.stateWiseSales = [];
    this.stateWiseRangeSales = [];
    this.monthWiseRangeSales = [];
    this.monthlySales = [];
    this.monthlyPayments = [];
    this.salesView = 'table';
    this.paymentsView = 'table';
    this.stateSalesView = 'table';
    this.stateRangeSalesView = 'table';
    this.monthRangeSalesView = 'graph';
    this.isStateSalesLoading = true;
    this.isStateRangeSalesLoading = true;
    this.isMonthRangeSalesLoading = true;
    this.dateRange = {
      start: null,
      end: null
    };
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  get salesSeries() {
    return [{
      name: 'Sales Amount',
      data: this.top50dealersSales.map(dealer => dealer.totalAmount || 0)
    }];
  }
  get salesChartOptions() {
    return {
      chart: {
        type: 'bar',
        height: 360,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '75%'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: this.top50dealersSales.map(dealer => dealer.dealer_name || 'Unknown'),
        labels: {
          show: false
        }
      },
      yaxis: {
        title: {
          text: '',
          style: {
            fontSize: '14px',
            fontWeight: 600,
            color: '#2c3e50'
          }
        },
        labels: {
          formatter: val => `${val.toLocaleString()}`,
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        }
      },
      colors: ['#409EFF'],
      fill: {
        opacity: 1
      },
      tooltip: {
        x: {
          show: true
        },
        y: {
          formatter: val => `${val.toLocaleString()}`
        }
      },
      grid: {
        borderColor: '#ebeef5'
      }
    };
  }
  get paymentsSeries() {
    return [{
      name: 'Payments Amount',
      data: this.top50dealersPayments.map(dealer => dealer.totalAmount || 0)
    }];
  }
  get paymentsChartOptions() {
    return {
      chart: {
        type: 'bar',
        height: 360,
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '75%'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: this.top50dealersPayments.map(dealer => dealer.dealer_name || 'Unknown'),
        labels: {
          show: false
        }
      },
      yaxis: {
        title: {
          text: '',
          style: {
            fontSize: '14px',
            fontWeight: 600,
            color: '#2c3e50'
          }
        },
        labels: {
          formatter: val => `${val.toLocaleString()}`,
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        }
      },
      colors: ['#409EFF'],
      fill: {
        opacity: 1
      },
      tooltip: {
        x: {
          show: true
        },
        y: {
          formatter: val => `${val.toLocaleString()}`
        }
      },
      grid: {
        borderColor: '#ebeef5'
      }
    };
  }
  get stateSalesSeries() {
    return this.stateWiseSales.filter(state => state && state.totalAmount && state.state_name).map(state => parseFloat(state.totalAmount) || 0);
  }
  get stateSalesChartOptions() {
    return {
      chart: {
        type: 'pie',
        height: 360,
        width: '100%',
        toolbar: {
          show: false
        }
      },
      labels: this.stateWiseSales.filter(state => state && state.totalAmount && state.state_name).map(state => state.state_name || 'Unknown'),
      dataLabels: {
        enabled: true,
        formatter: val => `${Math.round(val)}%`
      },
      tooltip: {
        y: {
          formatter: val => `${val.toLocaleString()}`
        }
      },
      colors: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#B3E5FC', '#FF9A9E', '#A1C4FD', '#84FAB0', '#8FD3F4'],
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    };
  }
  get stateRangeSalesSeries() {
    return [{
      name: 'Olive Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.oliveSeries) || 0)
    }, {
      name: 'Oura Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.ouraSeries) || 0)
    }, {
      name: 'Deluxe Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.deluxeSeries) || 0)
    }, {
      name: 'MCB Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.mcbSeries) || 0)
    }, {
      name: 'Lyfe Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.lyfeSeries) || 0)
    }, {
      name: 'Viva Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.vivaSeries) || 0)
    }, {
      name: 'Curvy Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.curvySeries) || 0)
    }, {
      name: 'I-Connect Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.iconnectSeries) || 0)
    }, {
      name: 'Epic Series',
      data: this.stateWiseRangeSales.map(state => parseFloat(state.epicSeries) || 0)
    }];
  }
  get stateRangeSalesChartOptions() {
    return {
      chart: {
        type: 'bar',
        height: 400,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: true,
          type: 'x',
          autoScaleYaxis: true
        }
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '50%'
        }
      },
      dataLabels: {
        enabled: false
      },
      xaxis: {
        categories: this.stateWiseRangeSales.map(state => state.state || 'Unknown'),
        labels: {
          show: true,
          rotate: -45,
          trim: false,
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        },
        tickAmount: this.stateWiseRangeSales.length - 1,
        axisTicks: {
          show: true
        }
      },
      yaxis: {
        labels: {
          formatter: val => `${val.toLocaleString()}`,
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        }
      },
      colors: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#B3E5FC', '#FF9A9E', '#A1C4FD', '#84FAB0', '#8FD3F4'],
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: val => `${val.toLocaleString()}`
        }
      },
      grid: {
        borderColor: '#ebeef5'
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left'
      }
    };
  }
  get monthRangeSalesSeries() {
    return [{
      name: 'Olive Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.oliveSeries) || 0)
    }, {
      name: 'Oura Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.ouraSeries) || 0)
    }, {
      name: 'Deluxe Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.deluxeSeries) || 0)
    }, {
      name: 'MCB Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.mcbSeries) || 0)
    }, {
      name: 'Lyfe Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.lyfeSeries) || 0)
    }, {
      name: 'Viva Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.vivaSeries) || 0)
    }, {
      name: 'Curvy Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.curvySeries) || 0)
    }, {
      name: 'I-Connect Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.iconnectSeries) || 0)
    }, {
      name: 'Epic Series',
      data: this.monthWiseRangeSales.map(month => parseFloat(month.epicSeries) || 0)
    }];
  }
  get monthRangeSalesChartOptions() {
    return {
      chart: {
        type: 'bar',
        height: 400,
        stacked: true,
        toolbar: {
          show: false
        },
        zoom: {
          enabled: true
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -25,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: true,
          borderRadius: 10,
          borderRadiusApplication: 'end',
          borderRadiusWhenStacked: 'last',
          dataLabels: {
            total: {
              enabled: false,
              style: {
                fontSize: '13px',
                fontWeight: 900
              }
            }
          }
        }
      },
      xaxis: {
        type: 'category',
        categories: this.monthWiseRangeSales.map(month => month.month || 'Unknown'),
        labels: {
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        }
      },
      yaxis: {
        title: {
          text: '',
          style: {
            fontSize: '14px',
            fontWeight: 600,
            color: '#2c3e50'
          }
        },
        labels: {
          formatter: val => `${val.toLocaleString()}`,
          style: {
            fontSize: '12px',
            colors: '#666'
          }
        }
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      },
      colors: ['#409EFF', '#67C23A', '#E6A23C', '#F56C6C', '#B3E5FC', '#FF9A9E', '#A1C4FD', '#84FAB0', '#8FD3F4'],
      tooltip: {
        y: {
          formatter: val => `${val.toLocaleString()}`
        }
      },
      grid: {
        borderColor: '#ebeef5'
      }
    };
  }
  activated() {
    this.fetchAllData();
  }
  async handleSearch() {
    await this.fetchAllData();
  }
  async fetchAllData() {
    this.isStateSalesLoading = true;
    this.isStateRangeSalesLoading = true;
    this.isMonthRangeSalesLoading = true;
    try {
      const query = this.dateRange.start && this.dateRange.end ? {
        startDate: this.dateRange.start,
        endDate: this.dateRange.end
      } : {};
      await Promise.all([this.fetchTop50DealersSales(query), this.fetchTop50DealersPayments(query), this.fetchStateWiseSales(query), this.fetchStateWiseRangeSales(query), this.fetchMonthWiseRangeSales(query)]);
    } finally {
      this.isStateSalesLoading = false;
      this.isStateRangeSalesLoading = false;
      this.isMonthRangeSalesLoading = false;
    }
  }
  async fetchTop50DealersSales(query) {
    try {
      const response = await getTop50DealersSales(query);
      this.top50dealersSales = response.data || [];
    } catch (error) {
      console.error('Error fetching top 50 dealers sales:', error);
      this.top50dealersSales = [];
    }
  }
  async fetchTop50DealersPayments(query) {
    try {
      const response = await getTop50DealersPayments(query);
      this.top50dealersPayments = response.data || [];
    } catch (error) {
      console.error('Error fetching top 50 dealers payments:', error);
      this.top50dealersPayments = [];
    }
  }
  async fetchStateWiseSales(query) {
    try {
      const response = await fetchStateWiseSales(query);
      this.stateWiseSales = response.data || [];
    } catch (error) {
      console.error('Error collecting state-wise sales:', error);
      this.stateWiseSales = [];
    }
  }
  async fetchStateWiseRangeSales(query) {
    try {
      const response = await fetchStateWiseRangeSales(query);
      this.stateWiseRangeSales = response.data || [];
    } catch (error) {
      console.error('Error fetching state-wise range sales:', error);
      this.stateWiseRangeSales = [];
    }
  }
  async fetchMonthWiseRangeSales(query) {
    try {
      const response = await fetchMonthWiseRangeSales(query);
      this.monthWiseRangeSales = response.data || [];
    } catch (error) {
      console.error('Error fetching month-wise range sales:', error);
      this.monthWiseRangeSales = [];
    }
  }
  toggleSalesView() {
    this.salesView = this.salesView === 'table' ? 'graph' : 'table';
  }
  togglePaymentsView() {
    this.paymentsView = this.paymentsView === 'table' ? 'graph' : 'table';
  }
  toggleStateSalesView() {
    this.stateSalesView = this.stateSalesView === 'table' ? 'graph' : 'table';
  }
  toggleStateRangeSalesView() {
    this.stateRangeSalesView = this.stateRangeSalesView === 'table' ? 'graph' : 'table';
  }
  toggleMonthRangeSalesView() {
    this.monthRangeSalesView = this.monthRangeSalesView === 'table' ? 'graph' : 'table';
  }
  // Download Excel methods for each container
  downloadSalesExcel() {
    const data = this.top50dealersSales.map(item => ({
      Name: item.dealer_name || 'Unknown',
      Branch: item.branch_code || '',
      Amount: +item.totalAmount || 0
    }));
    this.exportToExcel(data, 'Sales_Leaderboard');
  }
  downloadPaymentsExcel() {
    const data = this.top50dealersPayments.map(item => ({
      Name: item.dealer_name || 'Unknown',
      Branch: item.branch_code || '',
      Amount: +item.totalAmount || 0
    }));
    this.exportToExcel(data, 'Payments_Leaderboard');
  }
  downloadStateSalesExcel() {
    const data = this.stateWiseSales.map(item => ({
      'State ID': item.address_stateId || '',
      State: item.state_name || 'Unknown',
      Amount: +item.totalAmount || 0
    }));
    this.exportToExcel(data, 'State_Wise_Sales');
  }
  downloadStateRangeSalesExcel() {
    const data = this.stateWiseRangeSales.map(item => ({
      State: item.state || 'Unknown',
      'Olive Series': +item.oliveSeries || 0,
      'Oura Series': +item.ouraSeries || 0,
      'Deluxe Series': +item.deluxeSeries || 0,
      'MCB Series': +item.mcbSeries || 0,
      'Lyfe Series': +item.lyfeSeries || 0,
      'Viva Series': +item.vivaSeries || 0,
      'Curvy Series': +item.curvySeries || 0,
      'I-Connect Series': +item.iconnectSeries || 0,
      'Epic Series': +item.epicSeries || 0,
      'Total Sales': +item.totalSales || 0
    }));
    this.exportToExcel(data, 'State_Wise_Range_Sales');
  }
  downloadMonthRangeSalesExcel() {
    const data = this.monthWiseRangeSales.map(item => ({
      Month: item.month || 'Unknown',
      'Olive Series': +item.oliveSeries || 0,
      'Oura Series': +item.ouraSeries || 0,
      'Deluxe Series': +item.deluxeSeries || 0,
      'MCB Series': +item.mcbSeries || 0,
      'Lyfe Series': +item.lyfeSeries || 0,
      'Viva Series': +item.vivaSeries || 0,
      'Curvy Series': +item.curvySeries || 0,
      'I-Connect Series': +item.iconnectSeries || 0,
      'Epic Series': +item.epicSeries || 0,
      'Total Sales': +item.totalSales || 0
    }));
    this.exportToExcel(data, 'Month_Wise_Range_Sales');
  }
  exportToExcel(data, fileName) {
    if (!data.length) {
      this.$message.warning('No data available to export.');
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${fileName}_${new Date().toISOString().split('T')[0]}.xlsx`);
  }
};
default_1 = __decorate([Component({
  name: 'Dashboard',
  components: {
    apexchart: VueApexCharts,
    VueCtkDateTimePicker
  }
})], default_1);
export default default_1;